"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractListQuery = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var ContractListQuery = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ContractListQuery, _super);
    function ContractListQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '借款合同列表';
        _this.code = '101130';
        _this.desc = '借款合同列表';
        _this.requestParams = new cashLoanAuth_1.ContractListQueryRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ContractListQuery;
}(service_1.BaseService));
exports.ContractListQuery = ContractListQuery;
//# sourceMappingURL=contractListQuery.js.map